import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { StatusBadge } from "../../components/StatusBadge";

export default function AdminStatusHistory() {
  const { selectedSite } = useAuth();
  const [changes, setChanges] = useState([]);
  useEffect(() => { api.get(`/status-changes?site=${selectedSite}`).then(({ data }) => setChanges(data)); }, [selectedSite]);

  return (
    <div className="space-y-2.5" data-testid="admin-status-history-panel">
      {changes.length === 0 && <p className="text-sm text-slate-500">Aucun changement de statut enregistré.</p>}
      {changes.map((c) => (
        <div key={c.Changement_ID} data-testid={`admin-history-row-${c.Changement_ID}`} className="rounded-xl border border-slate-800 bg-[#121820] p-4">
          <div className="flex items-center justify-between flex-wrap gap-2">
            <div className="text-sm font-semibold text-slate-100">{c.Front_Libelle} <span className="text-slate-500 font-mono text-xs">({c.Front_ID})</span></div>
            <div className="text-xs text-slate-500">{c.Date_Heure ? new Date(c.Date_Heure).toLocaleString("fr-FR") : ""}</div>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <StatusBadge status={c.Ancien_Statut} /> <ArrowRight className="w-4 h-4 text-slate-500" /> <StatusBadge status={c.Nouveau_Statut} />
          </div>
          <div className="text-sm text-slate-300 mt-2"><b>Motif:</b> {c.Motif}</div>
          <div className="text-xs text-slate-500 mt-1">Validé par {c.Valide_Par_Nom} ({c.Role_Validateur})</div>
        </div>
      ))}
    </div>
  );
}
